import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { ArrowLeft, ArrowRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Stepper } from "@/components/stepper/stepper";

import { useJobOrderStore } from "@/stores/store";

export const Route = createFileRoute("/(planner-screens)/job-order/")({
  component: RouteComponent,
});

const steps = [
  { id: "assign", title: "Assign Resource" },
  { id: "review", title: "Review Job" },
  { id: "select", title: "Select Time" },
];

function RouteComponent() {
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();
  const jobOrderData = useJobOrderStore((state) => state.jobOrderData);

  const handleStepChange = (value: string) => {
    const findIndex = steps.findIndex((i) => i.id === value);
    setCurrentStep(findIndex);
  };
  return (
    <div className="aero:min-h-screen aero:bg-background">
      <header className="aero:border-b">
        <div className="aero:flex aero:items-center aero:p-4">
          <Button
            onClick={() => window.history.back()}
            intent="custom"
            design="text"
            className="aero:flex-none aero:gap-2"
          >
            <ArrowLeft className="aero:h-4 aero:w-4" />
            Back
          </Button>
          <div className="aero:grow aero:flex aero:justify-center aero:items-center">
            <Stepper
              steps={steps}
              currentStep={currentStep}
              onStepChange={handleStepChange}
            />
          </div>

          <div className="aero:flex-none aero:items-center aero:gap-4">
            <div className="aero:flex aero:items-center aero:gap-2">
              <span className="aero:!text-sm aero:!text-muted-foreground">
                Job Order No
              </span>
              <span className="aero:!font-mono">
                {jobOrderData?.jobOrderNo}
              </span>
            </div>
            <Button
              onClick={() =>
                navigate({
                  to: "/planner/list",
                  search: {
                    filters: undefined,
                    sorts: undefined,
                    search: undefined,
                  },
                })
              }
              intent="primary"
              design="text"
              className="aero:gap-2"
            >
              See Other Job
              <ArrowRight className="aero:h-4 aero:w-4" />
            </Button>
          </div>
        </div>
      </header>
      <div>{/* <Outlet /> */}</div>
    </div>
  );
}
